import { render, staticRenderFns } from "./tag-other.vue?vue&type=template&id=12d83232&scoped=true"
import script from "./tag-other.vue?vue&type=script&lang=js"
export * from "./tag-other.vue?vue&type=script&lang=js"
import style0 from "./tag-other.vue?vue&type=style&index=0&id=12d83232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d83232",
  null
  
)

export default component.exports